import coa from "../assets/logos/coa.jpeg";
import vwn from "../assets/logos/vwn.png";

const volunteering = {
  english: [
    {
      position: "Interpreter",
      company: "VluchtelingenWerk Nederland",
      date: "Apr 2016",
      period: "5 months",
      location: "The Hague - The Netherlands",
      logo: vwn,
    },
    {
      position: "Coordinator - Open Learning Centre ",
      company: "Central Agency for the Reception of Asylum Seekers (COA)",
      date: "May 2015",
      period: "6 months",
      location: "Gilze en Rijen - The Netherlands",
      logo: coa,
    },
  ],
  arabic: [
    {
      position: "مترجم",
      company: "VluchtelingenWerk Nederland",
      date: "Apr 2016",
      period: "خمسة أشهر",
      location: "لاهاي - هولندا",
      logo: vwn,
    },
    {
      position: "منسق في مركز التعلم المفتوح",
      company: "الوكالة المركزية لإستقبال اللاجئين - الكوا",
      date: "May 2015",
      period: "ستة أشهر",
      location: "خلزة - هولندا",
      logo: coa,
    },
  ],
};

export default volunteering;
